import script from "./TableSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./TableSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./TableSkeleton.vue?vue&type=style&index=0&id=eaed76c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eaed76c6"]])

export default __exports__